export const PAG_KEYS = [
  "astec_paginacao",
  "astec_paginacao_projetos",
  "astec_paginacao_cliente_rural",
  "astec_paginacao_projeto_por_lote"
];

export const PAG_PREFIX = "astec_paginacao";

/**
 * Remove uma única chave do localStorage de forma segura.
 * @param {string} chave
 * @returns {boolean} true se removeu; false caso contrário.
 */
export function limparPaginacao(chave) {
  try {
    if (localStorage.getItem(chave) !== null) {
      localStorage.removeItem(chave);
      return true;
    }
  } catch (error) {
    console.warn("Erro ao limpar localStorage (limparPaginacao):", error);
  }
  return false;
}

/**
 * Remove TODAS as chaves de paginação conhecidas e quaisquer chaves
 * que comecem com o prefixo `PAG_PREFIX`.
 * @returns {boolean} true se removeu alguma; false se nada foi removido.
 */
export const limparTodasPaginacoes = () => {
  let removidas = false;

  try {
    // Remove chaves conhecidas
    PAG_KEYS.forEach(k => {
      if (localStorage.getItem(k) !== null) {
        localStorage.removeItem(k);
        removidas = true;
      }
    });

    // Remove qualquer outra com o prefixo
    Object.keys(localStorage)
      .filter(k => k.startsWith(PAG_PREFIX))
      .forEach(k => {
        localStorage.removeItem(k);
        removidas = true;
      });

    return removidas;
  } catch (error) {
    console.warn("Erro ao limpar localStorage (limparTodasPaginacoes):", error);
    return false;
  }
};
